export const useHydraulicValidationHelper = () => {
  const getMinValue = (rules: any, data: any) => {
    const maxRules = rules?.filter(r => r.dependencyMode === 'le')
    const minRules = rules?.filter(r => r.dependencyMode === 'ge')
    let maxRulesMaxValue = null
    maxRules?.forEach(maxRule => {
      let maxRuleMaxValue = null
      if (maxRule?.ranges !== null && maxRule?.dependingOn && data) {
        const range = maxRule.ranges.find(ra => ra.dependingValue <= data[maxRule.dependingOn])
        maxRuleMaxValue = range === null ? null : range?.min === null ? data[maxRule.dependingOn] + range?.lowDelta : range?.min
      }
      maxRulesMaxValue = Math.max(maxRulesMaxValue, maxRuleMaxValue)
    })
    let minRulesMaxValue = null
    minRules?.forEach(minRule => {
      let minRuleMaxValue = null
      if (minRule && minRule.absolute !== null) {
        minRuleMaxValue = minRule.absolute
      } else if (minRule && minRule.delta !== null && minRule.dependingOn !== null && data) {
        minRuleMaxValue = data[minRule.dependingOn] + minRule.delta
      } else if (minRule && minRule.ranges !== null  && minRule.dependingOn !== null && data) {
        const range = minRule.ranges.sort((a, b) => b.dependingValue - a.dependingValue).find(ra => ra.dependingValue <= data[minRule.dependingOn])
        minRuleMaxValue = range === null ? null : range?.min === null ? data[minRule.dependingOn] + range.lowDelta : range?.min
      }
      minRulesMaxValue = Math.max(minRulesMaxValue, minRuleMaxValue)
    })
    return Math.max(minRulesMaxValue ?? maxRulesMaxValue, maxRulesMaxValue ?? minRulesMaxValue)
  }

  const getMaxValue = (rules: any, data: any) => {
    const maxRules = rules?.filter(r => r.dependencyMode === 'le')
    const minRules = rules?.filter(r => r.dependencyMode === 'ge')
    let minRulesMaxValue = null
    minRules?.forEach(minRule => {
      let minRuleMaxValue = null
      if (minRule?.ranges !== null && minRule?.dependingOn && data) {
        const range = minRule.ranges.sort((a, b) => b.dependingValue - a.dependingValue).find(ra => ra.dependingValue <= data[minRule.dependingOn])
        minRuleMaxValue = range === null ? null : range?.max === null ? data[minRule.dependingOn] + range?.highDelta : range?.max
      }
      minRulesMaxValue = minRulesMaxValue !== null ? Math.min(minRulesMaxValue, minRuleMaxValue) : minRuleMaxValue
    })
    let maxRulesMaxValue = null
    maxRules?.forEach(maxRule => {
      let maxRuleMaxValue = null
      if (maxRule && maxRule.absolute !== null) {
        maxRuleMaxValue = maxRule.absolute
      } else if (maxRule && maxRule.delta !== null && maxRule.dependingOn !== null && data) {
        maxRuleMaxValue = data[maxRule.dependingOn] + maxRule.delta
      } else if (maxRule && maxRule.ranges !== null  && maxRule.dependingOn !== null && data) {
        const range = maxRule.ranges.find(ra => ra.dependingValue <= data[maxRule.dependingOn])
        maxRuleMaxValue = range === null ? null : range?.max === null ? data[maxRule.dependingOn] + range.highDelta : range?.max
      }
      maxRulesMaxValue = maxRulesMaxValue !== null ? Math.min(maxRulesMaxValue, maxRuleMaxValue) : maxRuleMaxValue
    })
    return Math.min(minRulesMaxValue ?? maxRulesMaxValue, maxRulesMaxValue ?? minRulesMaxValue)
  }

  return {
    getMinValue,
    getMaxValue
  }
}
